// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-div-loader__container{display:flex;align-items:center;flex-direction:column}.w-div-loader__content{margin-top:24px}.w-div-loader p{margin-top:8px;font-size:16px!important}", ""]);
// Exports
module.exports = exports;
